import React, { ButtonHTMLAttributes, HTMLAttributes } from 'react';
import { Radio } from 'src/core/forms';
import classnames from 'classnames';

import classes from './RadioAccordion.scss';

type Props = {
    id: string;
    value: string | number;
    background?: boolean;
} & HTMLAttributes<any>;

export const RadioCard: React.FC<React.PropsWithChildren<Props>> = ({ value, id, background, children, ...rest }) => (
    <div
        className={classnames(classes.item, classes.itemCard, {
            [classes.background]: background,
        })}
        data-test-id="RadioCard"
    >
        <Radio className={classes.radio} value={value} id={id} />
        <label className={classnames(classes.label, classes.selectable)} htmlFor={id} {...rest}>
            {children}
        </label>
    </div>
);

export const RadioCardButton: React.FC<React.PropsWithChildren<{ onClick() } & ButtonHTMLAttributes<any>>> = ({
    onClick,
    children,
    ...rest
}) => (
    <div className={classnames(classes.item, classes.itemCard)} data-test-id="RadioCardButton">
        <span className={classes.radio} />
        <button type="button" className={classnames(classes.label, classes.selectable)} onClick={onClick} {...rest}>
            {children}
        </button>
    </div>
);
